import { FC } from 'react';
import mockEmptySchedule from 'assets/images/mock-schedule-empty.svg';
import { clsx } from 'clsx';

import { extractDay } from '../lib';
import { IEmptyCardScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const EmptyCardSchedule: FC<IEmptyCardScheduleProps> = ({
  isNotThisMonth,
  isWeekend,
  dataDate,
}) => {
  return (
    <div className={clsx(styles['calendar-schedule__card'])}>
      {isWeekend && (
        <div
          style={{
            position: 'absolute',
            background: 'var(--green-light-5)',
            width: '100%',
            height: '100%',
          }}
        ></div>
      )}
      {isNotThisMonth && !isWeekend && (
        <div
          style={{
            position: 'absolute',
            background: 'var(--gray-light-8)',
            width: '100%',
            height: '100%',
          }}
        ></div>
      )}
      <div
        className={clsx(styles['calendar-schedule__date'], {
          [styles['calendar-schedule__date_gray']]: isNotThisMonth,
        })}
      >
        <div className={styles['calendar-schedule__date-left']}>
          {dataDate.weekParity}
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-day'], {
            [styles['calendar-schedule__date-day_primary']]: dataDate.isPrimary,
          })}
        >
          {extractDay(dataDate.date)}
        </div>
      </div>
      <img
        src={mockEmptySchedule}
        alt="empty-schedule"
        width="112px"
        style={{ position: 'absolute', bottom: '12px', left: '7px' }}
      />
    </div>
  );
};
